import { Platform } from 'quasar'
import store from '../store'

export default ({ app, router, Vue }) => {
	if (Platform.is.cordova) {
		document.addEventListener("deviceready", (e) =>{
			// StatusBar.overlaysWebView(false)
			// StatusBar.backgroundColorByHexString('#000')

			// console.log(navigator.connection.type);

			// document.addEventListener("offline", (e) =>{
			// 	alert("NO_NETWORK");
			// 	store.dispatch('offline/SET_OFFLINE', [true])
			// }, false);

			// document.addEventListener("online", (e) =>{
			// 	alert("ONLINE");
			// 	store.dispatch('offline/SET_OFFLINE', [false])
			// }, false);
		}, false);
	}
}
